import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const LOAN_OPTIONS = [
  {amount:5500,fee:150},{amount:7800,fee:180},{amount:9800,fee:210},{amount:11200,fee:250},
  {amount:16800,fee:280},{amount:21200,fee:320},{amount:25600,fee:450},{amount:30000,fee:520},
  {amount:35400,fee:640},{amount:39800,fee:780},{amount:44200,fee:1060},{amount:48600,fee:1650},
];
const fmt = n => `Ksh ${Number(n).toLocaleString()}`;

export default function Calculator() {
  const navigate = useNavigate();
  const [amount, setAmount] = useState(15000);
  const [months, setMonths] = useState(2);
  const RATE = 0.10; // 10% flat per term
  const interest = Math.round(amount * RATE * months);
  const total = amount + interest;
  const monthly = Math.round(total / months);
  const nearest = LOAN_OPTIONS.reduce((p,c) =>
    Math.abs(c.amount-amount) < Math.abs(p.amount-amount) ? c : p
  );

  return (
    <>
      <Navbar />
      <div className="page-shell">
        <div className="page-inner">
          <div className="page-eyebrow">🧮 Free Tool</div>
          <h1 className="page-title">Loan Calculator</h1>
          <p className="page-sub">See exactly what you'll pay before applying</p>

          <div className="calc-card">
            <div className="calc-header">
              <p className="calc-amount-label">Loan Amount</p>
              <div className="calc-amount-val">{fmt(amount)}</div>
              <input type="range" className="calc-range" min="5500" max="48600" step="200"
                value={amount} onChange={e => setAmount(Number(e.target.value))} />
              <div className="calc-range-labels"><span>Ksh 5,500</span><span>Ksh 48,600</span></div>
            </div>

            <div className="calc-body">
              <p className="section-tag" style={{marginBottom:12}}>Repayment Term</p>
              <div style={{display:'flex',gap:10,marginBottom:24}}>
                {[1,2,3].map(m => (
                  <button key={m} onClick={() => setMonths(m)} style={{
                    flex:1,padding:'11px 0',borderRadius:'var(--r-md)',
                    border:`2px solid ${months===m?'var(--primary)':'var(--border-mid)'}`,
                    background:months===m?'var(--green-50)':'#fff',
                    color:months===m?'var(--primary)':'var(--text-muted)',
                    fontFamily:'DM Sans,sans-serif',fontSize:14,fontWeight:600,cursor:'pointer',transition:'all 0.18s',
                  }}>{m} {m===1?'Month':'Months'}</button>
                ))}
              </div>

              <div className="calc-breakdown">
                <p className="section-tag" style={{marginBottom:12}}>Breakdown</p>
                {[
                  ['Principal (Loan)', fmt(amount)],
                  [`Interest (10% × ${months} month${months>1?'s':''})`, fmt(interest)],
                  ['Processing Fee', `Ksh ${nearest.fee.toLocaleString()}`],
                ].map(([k,v]) => (
                  <div className="calc-row" key={k}>
                    <span style={{color:'var(--text-muted)',fontWeight:400}}>{k}</span>
                    <span style={{fontWeight:500}}>{v}</span>
                  </div>
                ))}
                <div className="calc-row-total">
                  <span>Total to Repay</span>
                  <span style={{color:'var(--primary)'}}>{fmt(total)}</span>
                </div>
              </div>

              <div className="calc-monthly">
                <div>
                  <div className="calc-monthly-label">Monthly Repayment</div>
                  <div className="calc-monthly-val">{fmt(monthly)}</div>
                </div>
                <span style={{fontSize:36}}>📅</span>
              </div>

              <div className="info-box-blue" style={{marginBottom:20}}>
                <span>ℹ️</span>
                <span>Estimate based on 10% interest. Processing fee is deducted from disbursement — not charged separately.</span>
              </div>

              <button className="btn-cta" onClick={() => navigate('/dashboard')}>Apply Now →</button>
              <button className="btn-secondary" style={{marginTop:10}} onClick={() => navigate('/dashboard')}>← Back</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
